export const GET_ORGANISATIONS_FOR_FILTER = "GET_ORGANISATIONS_FOR_FILTER";
export const GET_PRODUCTS_FOR_FILTER = "GET_PRODUCTS_FOR_FILTER";
export const GET_PROJECTS_FOR_FILTER = "GET_PROJECTS_FOR_FILTER";
export const GET_STATUS_FOR_FILTER = "GET_STATUS_FOR_FILTER";
export const GET_SELECTED_ITEMS_FOR_FILTER = "GET_SELECTED_ITEMS_FOR_FILTER";
export const FILTER_SECTION_BY_VALUE_FOR_FILTER = "FILTER_SECTION_BY_VALUE_FOR_FILTER";
export const GET_CONSULTANTS_FOR_FILTER = "GET_CONSULTANTS_FOR_FILTER";
export const GET_COST_HEADINGS_FOR_FILTER = "GET_COST_HEADINGS_FOR_FILTER";
